import { programActionData } from './program-action.model';


export const programActionInfoJson = [
  ...programActionData // ProgramAction靜態設定檔
];
